import { Organization as OrganizationComponent } from "../components/organization/Organization";

const Register = () => {
  return <OrganizationComponent />;
};

export default Register;
